module.exports = __webpack_public_path__ + "static/media/meu-perfil.48cfad5f.svg";